import * as React from 'react';

import wsCarinaTheme from '../../configs/carina-theme';
import classNames from 'classnames';
const { ThemeProvider } = require('@cvent/carina-theme-provider');
import { ThemeProvider as V1ThemeProvider } from '@cvent/carina/components/ThemeProvider';
import { Button } from '@cvent/carina/components/Button';

const styles = require('./MapRedoSearchControl.scss');
const controlStyles = require('./MapControl.scss');

interface Props {
    onClick: () => void;
}

export default function MapRedoSearchControl(props: Props) {
    return (
        <V1ThemeProvider theme={wsCarinaTheme}>
            <ThemeProvider theme={wsCarinaTheme}>
                <div className={classNames(controlStyles.mapControls, styles.redoButton)}>
                    <Button text='Re-do Search In This Area' onClick={props.onClick} />
                </div>
            </ThemeProvider>
        </V1ThemeProvider>
    );
}
